<template>
  <b-card no-body>

    <div class="card-body p-1">
      <div class="row">
        <div class="col-12 col-md-4">
          <b-form-group
            label="Phòng thu"
            label-for="title"
          >
            <v-select
              v-model="localSearchQuery.studio_id"
              :options="dataStudio"
              class="w-100"
              :reduce="(val) => val.id"
              label="name"
              placeholder="--Chọn--"
            />
          </b-form-group>
        </div>

        <!-- <div class="col-12 col-md-4">
          <b-form-group
            label="Ngày tạo"
            label-for="created_at"
          >
            <flat-pickr
              v-model="localSearchQuery.created_at"
              class="form-control"
              :config="configDateRange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
          </b-form-group>
        </div> -->
        <div class="col-12 col-md-4">
          <b-form-group
            label="Trạng thái"
            label-for="status"
          >
            <v-select
              v-model="localSearchQuery.status"
              :options="statusOptions"
              :reduce="val => val.id"
              label="label"
              placeholder="--Chọn--"
            />
          </b-form-group>
        </div>
        <!-- <div class="col-12 col-md-4">
          <b-form-group
            label="Từ khóa"
            label-for="title"
          >
            <b-form-input
              id="title"
              v-model="localSearchQuery.keyword"
              class="d-inline-block"
              placeholder="Từ khóa"
              @keyup.enter="updateSearchQuery"
            />
          </b-form-group>
        </div> -->

      </div>
      <div class="row">

        <div class="col-12 col-md-4">

          <b-button
            variant="primary"
            @click="updateSearchQuery"
            @keyup.enter="updateSearchQuery"
          >
            <feather-icon icon="SearchIcon" /> Tìm kiếm </b-button>

        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BButton, BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import useCategoryTypeDevice from './useCategoryTypeDevice';
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import store from '@/store'
import useRepair from './useRepair'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    flatPickr,
    BFormGroup,
    vSelect,

  },
  props: {
    searchQuery: ref({}),
  },

  setup(props, { emit }) {
    const { statusOptions } = useRepair();
    const localSearchQuery = ref({
      created_at: '',
      keyword: '',
      status: '',
      studio_id: '',
    })
    const dataStudio = ref([])
    const updateSearchQuery = () => {
      emit('search', localSearchQuery.value)
    }
    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });
    const getAllStudioIsNormal = () => {
      store.dispatch('studio/fetchAll', { isPaginate: 0 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            dataStudio.value = result.data;
          }
        })
        .catch(error => {
          // console.log('error', error)
        })
    }
    getAllStudioIsNormal()

    return {
      localSearchQuery,
      updateSearchQuery,
      configDate,
      configDateRange,
      statusOptions,
      dataStudio,
    };
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
